import React, { useContext } from "react";
import NotificationDetailContent from "./components/NotificationDetailContent";
import NotificationDetailContext from "features/metadesk/Notification/NotificationDetail/NotificationDetail.context";
import useNotificationCenterState from "features/metadesk/Notification/NotificationDetail/NotificationDetail.hooks";

const NotificationDetailContainer = () => {
  const { formData, setFormData } = useNotificationCenterState();
  return (
    <div>
      <NotificationDetailContext.Provider value={{ formData, setFormData }}>
        <NotificationDetailContent status="draft"></NotificationDetailContent>
      </NotificationDetailContext.Provider>
    </div>
  );
};

export default NotificationDetailContainer;
